import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function ProtectedRoute({ children, roles = [] }) {
  const { loading, user } = useAuth();
  const location = useLocation();
  if (loading) return <div aria-live="polite" className="auth-loading"><span className="loader" /><p>Checking your secure session…</p></div>;
  if (!user) return <Navigate replace state={{ from: location.pathname }} to="/login" />;
  if (roles.length && !roles.includes(user.role)) return <Navigate replace to="/403" />;
  return children;
}

export default ProtectedRoute;
